import type { LockerRoom } from '@/types';
import { formatRoom } from '@/lib/locker-utils';
import { ROOM_THEME } from './room-theme';

interface RoomChipProps {
  room: LockerRoom;
  /** Locker label; omit to show just the room name. */
  label?: string;
}

/** Room-tinted chip ("Male 7") — the same cue in grids, tables and modals. */
export function RoomChip({ room, label }: RoomChipProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap ${ROOM_THEME[room].chip}`}
    >
      {formatRoom(room)}
      {label ? ` ${label}` : ''}
    </span>
  );
}
